import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { IStatistic2Tab } from '@fi-app/statistic2/statistic2';
import { BehaviorSubject } from 'rxjs';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Statistic2HelperService } from '@fi-app/statistic2/statistic2-helper.service';
import { ObjectTypes } from '@fi-shared/types';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-statistic2-navigation-tabs',
    template: `
        <fi-navigation-tabs
          [tabsModel]="tabs"
          [selectedIndex]="selectedIndex"
          (selectedIndexChange)="onTabIndexChange($event)"
          >
          <ng-container ngProjectAs="header-right-content">
            <div class="ccm-page-header-button-group right-aligned">
              @if (listData) {
                <fi-items-list-more-menu-mobile [listModel]="listData">
                </fi-items-list-more-menu-mobile>
              }
        
              <fi-statistic2-header-add-report
                [isDashboardTabSelected]="isDashboardTabSelected()"
                [isReportsTabSelected]="isReportsTabSelected()"
                >
              </fi-statistic2-header-add-report>
            </div>
          </ng-container>
        </fi-navigation-tabs>
        `,
    styleUrls: ['./statistic2-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class Statistic2NavigationTabsComponent extends TabsModuleBase implements OnInit {
    private dashboardTab: IStatistic2Tab;
    private reportsTab: IStatistic2Tab;

    constructor(
        injector: Injector,
        private appTextService: AppTextService,
        private statistic2HelperService: Statistic2HelperService,
        private pageTitleService: PageTitleService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.dashboardTab = {
            Title: this.appTextService.get('statistic.dashboard'),
            Sref: FiStateNames.Statistic2.Dashboard,
            SrefParams: { reloadData: true },
        };
        this.reportsTab = {
            Title: this.appTextService.get('reports'),
            Sref: FiStateNames.Statistic2.Report.List,
        };

        this.tabs = [this.dashboardTab, this.reportsTab];

        super.updateSelectedTabFromState();
        this.pageTitleService.setTitleForList(ObjectTypes.Statistic2);
    }

    isDashboardTabSelected(): boolean {
        return this.stateService.current.name === FiStateNames.Statistic2.Dashboard;
    }

    isReportsTabSelected(): boolean {
        return this.stateService.current.name === FiStateNames.Statistic2.Report.List;
    }
}
